/* eslint-disable */
import React from "react";
import { BenefitGrid } from "../../../../types/enrollmentV2.types";
import {
	COREBenefitThumbnailMap,
	COREPFBBenefitThumbnailMap,
	VEBBenefitThumbnailMap
} from "../../../../constants/cartContents";
import CoreVebCard from "../corevebCardV2.tsx/CoreVebCardV2";
import { PFBDentalPlanImage, PFBVisionPlanImage } from "../../../../assets";
import { CorePanhandlePlansName } from "../../../../constants/plan";
import { GROUP_NUMBER } from "../../../../constants/groups";
import { Plan } from "../../../../types/plan.types";
import { VEBPlanSchema } from "../../../../types/VEBPlanSchema";

const renderCard = (
	data: BenefitGrid,
	index: number,
	isVEB: boolean,
	coreBenefits: BenefitGrid[],
	vebBenefits: BenefitGrid[],
	corePlans: Plan[],
	currentPlans: VEBPlanSchema[],
	futurePlans: VEBPlanSchema[],
	coreTrueCount?: any,
	vebTrueCount?: any,
	coreDependents?: any,
	vebDependents?: any,
	vebRiderCount?: any, // it handels riders for both veb and core plans 
	vebRiders?: any // it handels riders for both veb and core plans 
) => {
	const {
		plan_name,
		base_plan_name,
		sub_plan,
		total_premium,
		effective_date,
		benefit_end_date,
		termination_date,
		plan_code,
		enrollment_status,
		initial_effective_date,
		enrollments
	} = data;

	// Derived
	const isLastItem = index === (isVEB ? vebBenefits.length - 1 : coreBenefits.length - 1);

	const isPanhandlePlan =
		CorePanhandlePlansName.includes(plan_name) &&
		(enrollments as any[])[0]?.group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK;

	// Background image
	const backgroundImage = isVEB
		? VEBBenefitThumbnailMap[plan_name as keyof typeof VEBBenefitThumbnailMap]
		: isPanhandlePlan
		? COREPFBBenefitThumbnailMap[plan_name as keyof typeof COREPFBBenefitThumbnailMap]
		: COREBenefitThumbnailMap[plan_name as keyof typeof COREBenefitThumbnailMap];

	return (
		<div
			key={`${isVEB ? "veb" : "core"}-${plan_code}-${index}`}
			className="border-separater"
			style={{
				borderBottom: isLastItem ? "1px solid rgba(0, 0, 0, 0.2)" : "none",
				paddingBottom: isLastItem ? "16px" : "0"
			}}
		>
			<CoreVebCard
				backgroundImage={backgroundImage}
				plan_code={plan_code}
				plan_name={plan_name}
				base_plan_name={base_plan_name}
				sub_plan={sub_plan}
				enrollment_status={enrollment_status}
				total_premium={total_premium}
				effective_date={effective_date}
				benefit_end_date={benefit_end_date}
				termination_date={termination_date}
				enrollment_date={data.enrollment_date}
				initial_effective_date={initial_effective_date}
				enrollments={enrollments}
				coreTrueCount={coreTrueCount || {}}
				vebTrueCount={vebTrueCount || {}}
				coreDependents={coreDependents || {}}
				vebDependents={vebDependents || {}}
				vebRiderCount={vebRiderCount || {}}
				vebRiders={vebRiders || {}}
				corePlans={corePlans}
				currentPlans={currentPlans}
				futurePlans={futurePlans}
			/>
		</div>
	);
};

export default renderCard;
